import 'es6-object-assign/auto';
import $ from 'jquery';
import debounce from 'lodash/debounce';
import { mixin as clickaway } from 'vue-clickaway';

import { i18n } from '../../translation.js';
import './c-search.scss';
import template from './search.vhtml';

export default {
	template,
	mixins: [ clickaway ],
	props: {
		placeholderText: {
			type: String,
			default: '',
		},
		searchEngine: {
			type: String,
			default: 'default',
		},
		slideOut: {
			type: Boolean,
			default: false,
		},
		inputName: {
			type: String,
			default: null,
		},
		inputId: {
			type: String,
			default: null,
		},
		searchQuery: {
			type: String,
			default: null,
		},
		isLiveSearch: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			searchString: '',
			searchText: '',
			isFetching: false,
			isActive: false,
			isOpen: false,
			searchResults: [],
			selectedResult: -1,
		};
	},
	computed: {
		placeholder: function() {
			return this.placeholderText !== '' ? this.placeholderText + '...' : '';
		},
		hasSearchResults: function() {
			return this.searchResults.length > 0 && this.isActive;
		},
	},
	watch: {
		searchString() {
			this.isFetching = true;
			if ( this.searchString.length === 0 ) {
				this.searchResults = [];
				this.isFetching = false;
			} else {
				this.selectedResult = -1;
				$( '.c-search__results', this.$el ).scrollTop( 0 );
				this.fetchResults( this.searchString );
			}
		},
		isActive() {
			this.$emit( 'hide-nav', this.isActive );
		},
		hasSearchResults() {
			if ( !this.hasSearchResults ) {
				this.selectedResult = -1;
			}
		},
	},
	methods: {
		toggleActive() {
			this.isActive = !this.isActive;
		},
		toggleActiveTrue() {
			this.isActive = true;
			
		},
		toggleActiveFalse() {
			this.isActive = false;
			this.selectedResult = -1;
			$( '.c-search__input', this.$el ).blur();
		},
		toggleIsOpen() {
			if ( this.slideOut ) {
				this.isOpen = !this.isOpen;
			}
		},
		fetchResults: debounce( function() {
			getItems( this.searchString, this.searchEngine )
				.then( items => {
					if ( items ) {
						this.searchResults = items;
					}
				})
				.always( () => { 
					this.isFetching = false;
				});
		}, 500 ), 
		search( event, str ) {
			event.preventDefault();
			if ( !this.isLiveSearch && this.isActive ) {			
				const url = window.location.origin + '/' + window.siteData.language + '/?s=' + str;
				window.location.href = url;
			}
		},
		goDown() {
			const container = $( '.c-search__results', this.$el );
			if ( this.searchResults.length > 0 && this.searchResults.length - 1 > this.selectedResult ) {
				this.selectedResult++;
				const scrollTo = $( '.c-search__result-el.isSelected', this.$el );
				if ( this.selectedResult > 0 ) {
					const pos = scrollTo.next().offset().top - container.offset().top + container.scrollTop() - container.height() + scrollTo.next().height();
					container.scrollTop( pos );
				}
			} else {
				container.scrollTop( 0 );
				this.selectedResult = -1;
			}
		},
		goUp() {
			const container = $( '.c-search__results', this.$el );
			if ( this.searchResults.length > 0 && this.selectedResult > -1 ) {
				this.selectedResult--;
				if ( this.selectedResult !== -1 ) {
					const scrollTo = $( '.c-search__result-el.isSelected', this.$el );
					const pos = scrollTo.prev().offset().top - container.offset().top + container.scrollTop();
					container.scrollTop( pos );
				} 
			} else {
				this.selectedResult = this.searchResults.length - 1;
				container.scrollTop( container[0].scrollHeight );
			}
		},
		goTo() {
			if ( this.searchResults.length > 0 && this.selectedResult !== -1 ) {
				const url = this.searchResults[ this.selectedResult ].link;
				window.location.href = url;	
			}
		},
	},
	created() {
		if ( this.searchQuery !== null ) {
			this.searchText = this.searchQuery;
		}
	},
};

/**
 * Gets resumes from WP REST API
 *
 * @param {string} post_type
 * @param {string} [search=""]
 * @returns {JQueryPromise<any>}
 */
function getItems( searchString, searchEngine ) {
	const params = {
		's': searchString,
		'engine': searchEngine,
		'lang': window.siteData.language,
	};

	return $.get( `/wp-json/easv/v1/search`, params );
}

function blur( el ) {
	$( el, this.$el ).blur();
}

function scrollUp( el, parent, wrapper ) {
	const pos = $( el, wrapper ).position();
	$( parent, wrapper ).scrollTop( pos );
}



// WEBPACK FOOTER //
// ./assets/_js/components/search/search.js